/**
 * Shared modal chrome for the catalog admin dialogs (BON-161): centered overlay
 * card, title, body, and a Cancel / primary-action footer. Keeps each dialog
 * component focused on its own fields.
 */
import type { ReactNode } from 'react';

interface Props {
  title: string;
  submitLabel: string;
  saving: boolean;
  onClose: () => void;
  onSubmit: () => void;
  /** Tailwind classes for the primary button (defaults to moss). */
  submitClass?: string;
  maxWidth?: string;
  children: ReactNode;
}

export default function ModalShell({
  title,
  submitLabel,
  saving,
  onClose,
  onSubmit,
  submitClass = 'bg-moss-600 hover:bg-moss-700',
  maxWidth = 'max-w-md',
  children,
}: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div
        className={`bg-white dark:bg-[#1e2521] rounded-xl shadow-xl w-full ${maxWidth} mx-4 p-6 max-h-[85vh] overflow-y-auto`}
      >
        <h2 className="text-lg font-semibold text-stone-900 dark:text-stone-100 mb-4">{title}</h2>
        {children}
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={saving}
            className="px-4 py-2 text-sm rounded-lg border border-stone-300 dark:border-stone-600 text-stone-700 dark:text-stone-300 hover:bg-stone-50 dark:hover:bg-[#242d28] transition"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={saving}
            className={`px-4 py-2 text-sm rounded-lg text-white transition disabled:opacity-50 ${submitClass}`}
          >
            {submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
